module.exports = __webpack_public_path__ + "assets/img/thumb-Spark-Systems-Website.f5c279f2.jpg";